import "../assets/Modal.css";
import { defineComponent as n, openBlock as r, createElementBlock as s, createElementVNode as l, createVNode as i, withModifiers as a, unref as e } from "vue";
import { d as m } from "./debounce.F9gDQpy6.js";
import { _ } from "./XClose.vue_vue_type_style_index_0_lang.DygXUrp2.js";
import { t as c } from "./useModal.CgbJKM9V.js";
const d = { class: "thn--tool-terms__modal" }, p = ["innerHTML"], T = /* @__PURE__ */ n({
  __name: "Modal",
  props: {
    termsText: {}
  },
  setup(f) {
    const o = m(c, 200, { leading: !0, trailing: !1 });
    return (t, u) => (r(), s("div", d, [
      l("div", {
        class: "thn--tool-terms__modal-text",
        innerHTML: t.termsText
      }, null, 8, p),
      i(_, {
        onMousedown: a(e(o), ["left"]),
        onClick: e(o)
      }, null, 8, ["onMousedown", "onClick"])
    ]));
  }
});
export {
  T as _
};
//# sourceMappingURL=Modal.vue_vue_type_style_index_0_lang.DoY06x2T.js.map
